import { render } from "./DataExchange.vue?vue&type=template&id=0a294aa5&scoped=true"
import script from "./DataExchange.vue?vue&type=script&lang=js"
export * from "./DataExchange.vue?vue&type=script&lang=js"

import "./DataExchange.vue?vue&type=style&index=0&id=0a294aa5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a294aa5"],['__file',"src/views/DataExchange/DataExchange.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a294aa5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a294aa5', __exports__)) {
    api.reload('0a294aa5', __exports__)
  }
  
  module.hot.accept("./DataExchange.vue?vue&type=template&id=0a294aa5&scoped=true", () => {
    api.rerender('0a294aa5', render)
  })

}


export default __exports__